
//quadratic easing to decelerate the scroll
const easeOutQuart = function (x) {
    return 1 - Math.pow(1 - x, 4);
}



const animateScroll = function ({ targetPosition, initialPosition, duration }) {

    let start;
    let position;
    let animationFrame;

    const requestAnimationFrame = window.requestAnimationFrame;
    const cancelAnimationFrame = window.cancelAnimationFrame;

    //get max amount of pixels to scroll
    const maxAvailableScroll =
        document.documentElement.scrollHeight -
        document.documentElement.clientHeight;

    const amountofPixelsToScroll = initialPosition - targetPosition;

    const step = function (timestamp) {

        if (start === undefined) {
            start = timestamp;
        };

        const elapsed = timestamp - start;

        const relativeProgress = elapsed / duration;

        const easedProgress = easeOutQuart(relativeProgress);

        position = initialPosition - amountofPixelsToScroll * Math.min(easedProgress, 1);

        window.scrollTo(0, position);

        if (initialPosition !== maxAvailableScroll &&
            window.scrollY === maxAvailableScroll) {
            cancelAnimationFrame(animationFrame)
            return;
        };

        if (elapsed < duration) {
            animationFrame = requestAnimationFrame(step);
        };



    };
    animationFrame = requestAnimationFrame(step);
};

export default animateScroll;